import { render, staticRenderFns } from "./AppFeatureComponent.vue?vue&type=template&id=39cb4710&"
import script from "./AppFeatureComponent.vue?vue&type=script&lang=js&"
export * from "./AppFeatureComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports